module.exports = __webpack_public_path__ + "assets/17ce95f37220ce77466d6f62d6078e44.png";